export enum RetailerFilter {
  MyServiceOnly = 1,
  AssignmentToUsers = 2,
  AssignmentToRegions = 3,
  MyServiceClaimPurchase = 4,
  MyServiceClaimServicing = 5,
  SellingProtectionPlan = 6,
  SellingJewelryProtectionPlan = 7
}
